<template>
  <qx-card-form title="结算价" v-show="$route.query.serviceType === '1'">
    <OilPriceDialog ref="oilPriceDialog" />
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="settlementType" slot-scope="prop">
        <el-radio-group
          v-model="prop.form.settlementType"
        >
          <section class="radioBox">
            <el-radio :label="1">浮动价结算</el-radio>
            <el-input
              class="inputBox"
              v-model="otherFormData.floatBalanceBill"
              placeholder="请输入浮动价"
            >
              <span slot="suffix" class="unit">%</span>
            </el-input>
            <span class="primary cur radioText" @click="showOilPrice"
              >发改委挂牌油价</span
            >
            <el-tooltip
              content="浮动价结算：按照发改委各省的油价剩余折扣作为结算单价"
            >
              <i class="el-icon-question warning radioText"></i>
            </el-tooltip>
          </section>
          <section class="radioBox">
            <el-radio :label="2">固定价结算</el-radio>
            <el-input
              class="inputBox"
              v-model="otherFormData.fixedBalanceBill"
              placeholder="请输入固定价"
            >
              <span slot="suffix" class="unit">元/升</span>
            </el-input>
          </section>
          <section class="radioBox">
            <el-radio :label="3">现场价</el-radio>
            <el-tooltip
              content="浮动价结算：按照发改委各省的油价剩余折扣作为结算单价"
            >
              <i class="el-icon-question warning radioText"></i>
            </el-tooltip>
          </section>
        </el-radio-group>
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import OilPriceDialog from 'components/oilPriceDialog/oilPriceDialog';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    OilPriceDialog,
  },
  data () {
    return {
      otherFormData: {
        floatBalanceBill: '', // 浮动价结算
        fixedBalanceBill: '', // 固定价结算
      },
      baseForm: {
        form: [
          {
            label: '结算类型',
            value: 'settlementType',
            default: 1,
            slot: true,
          },
        ],
        rules: {
          balanceType: [ // 结算类型
            { required: true, message: '请选择结算类型', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    showOilPrice () {
      this.$refs.oilPriceDialog.show();
    },
    async getList () {
      const enumsData = await getEnumList({
        codeType: 'BALANCE_TYPE',
      });
      this.baseForm.balanceTypeOptions = enumsData[0];
    },
    handleLabelTypeChange () {
      const labelType = this.$refs.baseForm.getVal('balanceType');
      let isNotAuto = labelType === '1';
      const tar = ['collection'];
      this.baseForm.form.forEach((item) => {
        if (tar.indexOf(item.value) !== -1) {
          item.hide = isNotAuto;
        }
      });
    },
    handleSettlementTypeSub () { // 参照旧版的提交参数
      const settlementType = this.$refs.baseForm.getVal('settlementType');
      let settlementData = {};
      if (settlementType === 1) {
        settlementData = {
          fixedBalanceBill: '',
          localeBalanceState: 0,
        };
      } else if (settlementType === 2) {
        settlementData = {
          floatBalanceBill: '',
          localeBalanceState: 0,
        };
      } else if (settlementType === 3) {
        settlementData = {
          floatBalanceBill: '',
          fixedBalanceBill: '',
          localeBalanceState: 1,
        };
      }
      return settlementData;
    },
    async cacheData () {
      let res = await this.$refs.baseForm.getVal();
      res = {
        floatBalanceBill: this.otherFormData.floatBalanceBill, // 浮动价结算
        fixedBalanceBill: this.otherFormData.fixedBalanceBill, // 固定价结算
        ...this.handleSettlementTypeSub(),
      };
      return res;
    },

    async sub () {
      let result = {};
      const formData = await this.$refs.baseForm.sub();
      if (formData) {
        result = {
          floatBalanceBill: this.otherFormData.floatBalanceBill, // 浮动价结算
          fixedBalanceBill: this.otherFormData.fixedBalanceBill, // 固定价结算
          ...this.handleSettlementTypeSub(),
        };
      }
      return result;
    },
    init (data = {}) {
      if (data.floatBalanceBill) { // 浮动价结算
        data.settlementType = 1;
      } else if (data.fixedBalanceBill) { // 固定价结算
        data.settlementType = 2;
      } else if (data.localeBalanceState) { // 现场价
        data.settlementType = 3;
      } else {
        data.settlementType = 1;
      }
      this.$refs.baseForm.setVal('form', data);
      this.setFormVal(this.otherFormData, data);
      this.handleLabelTypeChange();

      this.setFormRuleAttr({
        rules: this.baseForm.rules,
        attr: 'required',
        value: this.$route.query.serviceType === '1',
      });
    },
  },
};
</script>

<style scoped lang="scss">
.radioBox {
  height: 40px;
  line-height: 40px;
  .radioText {
    margin-left: 4px;
  }
}
</style>
